import React, { useEffect, useMemo, useState } from "react";
import Card from "@material-tailwind/react/Card";
import { toast } from "react-toastify";

import Skeltons from "../../../../components/loading/Skeltons";
import { Colors } from "../../../../assets/Colors";
import { getTarifUangSaku, rupiah, simpanTarifUangSaku } from "./perjalananDinasApi";

// Master tarif uang saku per hari per jabatan — dipakai kategori Dinas Penugasan
// (uang saku = tarif x jumlah hari). Tarif 0 = belum diisi. Perubahan tarif hanya berlaku
// untuk pengajuan yang disimpan sesudahnya (pengajuan lama menyimpan snapshot tarif).
const TarifUangSakuPage = () => {
  const [rows, setRows] = useState([]);
  const [asli, setAsli] = useState({});
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [saving, setSaving] = useState(false);

  const muat = async () => {
    setLoading(true);
    try {
      const d = await getTarifUangSaku();
      setRows(d.map((r) => ({ ...r, TarifPerHari: String(r.TarifPerHari) })));
      setAsli(Object.fromEntries(d.map((r) => [r.JabatanID, String(r.TarifPerHari)])));
    } catch (e) {
      toast.error(e.message, { position: "bottom-right" });
    }
    setLoading(false);
  };
  useEffect(() => {
    muat();
  }, []);

  const berubah = useMemo(() => rows.filter((r) => r.TarifPerHari !== asli[r.JabatanID]), [rows, asli]);
  const tampil = rows.filter((r) => (r.NamaJabatan || "").toLowerCase().includes(search.toLowerCase()));
  const belumIsi = rows.filter((r) => !Number(r.TarifPerHari) && r.JumlahKaryawan > 0).length;

  const simpan = async () => {
    setSaving(true);
    try {
      await simpanTarifUangSaku(berubah.map((r) => ({ JabatanID: r.JabatanID, TarifPerHari: Number(r.TarifPerHari) || 0 })));
      toast.success(`${berubah.length} tarif disimpan`, { position: "bottom-right", autoClose: 3000 });
      await muat();
    } catch (e) {
      toast.error(e.message, { position: "bottom-right" });
    }
    setSaving(false);
  };

  return (
    <div className="md:ml-64">
      <div style={{ background: Colors.primary }} className="pt-14 pb-16 px-3 md:px-8 h-auto" />
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              {loading ? (
                <Skeltons />
              ) : (
                <>
                  <div className="px-4 pt-4">
                    <h2 className="text-lg font-bold text-gray-800">Tarif Uang Saku per Jabatan</h2>
                    <p className="text-sm text-gray-500">
                      Tarif per hari untuk Perjalanan Dinas kategori Penugasan. Kosong/0 = belum diisi.
                      {belumIsi > 0 && (
                        <span className="text-amber-600 font-semibold">
                          {" "}
                          {belumIsi} jabatan yang punya karyawan aktif belum punya tarif.
                        </span>
                      )}
                    </p>
                  </div>
                  <div className="flex w-full justify-between px-4 pt-3 flex-col sm:flex-row gap-2">
                    <input
                      type="text"
                      placeholder="Cari jabatan"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 w-full sm:w-96"
                    />
                    <button
                      onClick={simpan}
                      disabled={berubah.length === 0 || saving}
                      className="bg-green-600 hover:bg-green-700 disabled:opacity-40 text-white font-semibold py-2 px-4 rounded shadow"
                    >
                      {saving ? "Menyimpan…" : `Simpan perubahan (${berubah.length})`}
                    </button>
                  </div>
                  <div className="overflow-x-auto px-4 py-4">
                    <table className="table-auto w-full text-sm text-left text-gray-500">
                      <thead className="text-xs text-orange-600 uppercase bg-gray-50">
                        <tr>
                          <th className="py-3 px-4">Jabatan</th>
                          <th className="py-3 px-4">Karyawan Aktif</th>
                          <th className="py-3 px-4 w-64">Tarif / Hari (Rp)</th>
                          <th className="py-3 px-4">Terbaca</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tampil.map((r, i) => (
                          <tr key={r.JabatanID} className={i % 2 === 0 ? "bg-gray-50 border-b" : "bg-white border-b"}>
                            <td className="py-2 px-4">{r.NamaJabatan}</td>
                            <td className="py-2 px-4">{r.JumlahKaryawan}</td>
                            <td className="py-2 px-4">
                              <input
                                value={r.TarifPerHari}
                                inputMode="decimal"
                                onChange={(e) => {
                                  const v = e.target.value.replace(/[^0-9.]/g, "");
                                  setRows((l) => l.map((x) => (x.JabatanID === r.JabatanID ? { ...x, TarifPerHari: v } : x)));
                                }}
                                className={
                                  "w-full text-right border rounded py-2 px-3 outline-none " +
                                  (r.TarifPerHari !== asli[r.JabatanID] ? "border-amber-500 bg-amber-50" : "border-gray-300")
                                }
                              />
                            </td>
                            <td className="py-2 px-4">{rupiah(r.TarifPerHari)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TarifUangSakuPage;
